import { useLocation } from "react-router-dom";

const PolicyInfo = () => {
  const location = useLocation();
  const { policy } = location.state;
  console.log(policy, "Policy Details");
  return (
      <div className="row">
        <h4>My Policy</h4>
        <ul className="PolicyDetails">
          <li>
            Customer Name: <span>{policy.CustomerName}</span>
          </li>
          <li>
            Insurer Name: <span>{policy.InsurerName}</span>
          </li>
          <li>
            Policy EndDate: <span>{policy.PolicyEndDate}</span>
          </li>
          <li>
            Policy No: <span>{policy.PolicyNo}</span>
          </li>
          <li>
            Policy Start Date: <span>{policy.PolicyStartDate}</span>
          </li>
          <li>
            Policy SubType: <span>{policy.PolicySubType}</span>
          </li>
          <li>
            Policy Type: <span>{policy.PolicyType}</span>
          </li>
          <li>
            Relation: <span>{policy.Relation}</span>
          </li>
          <li>
            Vehicle Fuel Type: <span>{policy.VehicleFuelType}</span>
          </li>
          <li>
            Vehicle Make: <span>{policy.VehicleMake}</span>
          </li>
          <li>
            Vehicle Model: <span>{policy.VehicleModel}</span>
          </li>
          <li>
            Vehicle No: <span>{policy.VehicleNo}</span>
          </li>
          <li>
            Vehicle Variant: <span>{policy.VehicleVariant}</span>
          </li>
          <li>
            Claims Count: <span>{policy.ClaimsCount}</span>
          </li>
        </ul>
      </div>
  );
};

export default PolicyInfo;
